import React from "react"
import { motion } from "framer-motion"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import { springVariants, rightVariants, leftVariants, springViewport } from '../utils/framerVariants'

const StickyQuote = ({ data }) => {

  const isGerman = typeof window !== 'undefined' && window.location.pathname.includes('/de/');
  const isOpposite = data.stickyQuoteDirection && data.stickyQuoteDirection.startsWith("Opposite")
  const quoteClasses = isGerman ? "quote text-center text-headline tracking-headline leading-[1.15] font-normal" : "font-normal text-headline tracking-headline leading-[1.15] text-center";
  const quoteText = isGerman ? `„${data.stickyQuote}“` : `“${data.stickyQuote}”`;


  return (
    <>
      {isOpposite ? (
        <article className="container mx-auto max-w-6xl lg:max-w-7xl 2xl:max-w-8xl pb-0 md:pb-24 lg:pb-32 xl:pb-48 mb-16 md:mb-24 lg:mb-32 xl:mb-48 px-0 sm:px-8 md:px-24 lg:px-24 xl:px-24">
          <div className="flex flex-col sm:flex-row">
            <div className="sm:basis-5/12 basis-full">
              <div className="sm:sticky sm:top-48 -mb-0 md:-mb-24 lg:-mb-32 xl:-mb-48">
                {data.stickyQuotemedia && <motion.div
                  variants={springVariants}
                  initial="invisible"
                  whileInView="visible"
                  viewport={springViewport}
                  className="pr-0 sm:pr-12 md:pr-16 mb-8 sm:mb-0 sm:mt-2"
                  >
                  <GatsbyImage
                    image={getImage(data.stickyQuotemedia.file)}
                    alt={data.stickyQuotemedia.alternativeText || "Alternative Text missing"}
                  />
                  {data.stickyQuotemedia.caption && <p className="inline-flex pl-4 pr-16 sm:pl-0 sm:pr-0 mt-2 mb-0 text-text-sm tracking-text-sm leading-text-sm text-black/50 max-w-xl">{data.stickyQuotemedia.caption}</p>}
                </motion.div>
                }
              </div>
            </div>
            <div className="sm:basis-7/12 basis-full pr-4 sm:pr-0 pl-4 lg:pl-12 -mb-0 md:-mb-24 lg:-mb-32 xl:-mb-48">
              <blockquote className={quoteClasses}>
                {data.stickyQuote && (
                  <motion.div
                    variants={springVariants}
                    initial="invisible"
                    whileInView="visible"
                    viewport={springViewport}
                  >
                    {quoteText}
                  </motion.div>
                )}
                {data.stickyQuoteauthor && (
                  <motion.cite
                    variants={springVariants}
                    initial="invisible"
                    whileInView="visible"
                    className="text-text tracking-text leading-text mt-8 md:mt-12 block max-w-md mx-auto"
                    viewport={springViewport}
                  >
                    {data.stickyQuoteauthor}
                  </motion.cite>
                )}
              </blockquote>
            </div>
          </div>
        </article>
      ) : (
        <article className="container mx-auto max-w-6xl lg:max-w-7xl 2xl:max-w-8xl pb-0 md:pb-24 lg:pb-32 xl:pb-48 mb-16 md:mb-24 lg:mb-32 xl:mb-48 px-0 sm:px-8 md:px-24 lg:px-24 xl:px-24">
          <div className="flex sm:flex-row flex-col-reverse">
            <div className="sm:basis-7/12 basis-full pl-4 sm:pl-0 pr-4 lg:pr-12 -mb-0 md:-mb-24 lg:-mb-32 xl:-mb-48">
              <blockquote className={quoteClasses}>
                {data.stickyQuote && (
                  <motion.div
                    variants={springVariants}
                    initial="invisible"
                    whileInView="visible"
                    viewport={springViewport}
                  >
                    {quoteText}
                  </motion.div>
                )}
                {data.stickyQuoteauthor && (
                  <motion.cite
                    variants={springVariants}
                    initial="invisible"
                    whileInView="visible"
                    className="text-text tracking-text leading-text mt-8 md:mt-12 block max-w-md mx-auto"
                    viewport={springViewport}
                  >
                    {data.stickyQuoteauthor}
                  </motion.cite>
                )}
              </blockquote>
            </div>
            <div className="sm:basis-5/12 basis-full">
              <div className="sm:sticky sm:top-48 -mb-0 md:-mb-24 lg:-mb-32 xl:-mb-48 pb-8 sm:pb-0">
                {data.stickyQuotemedia && <motion.div
                  variants={springVariants}
                  initial="invisible"
                  whileInView="visible"
                  viewport={springViewport}
                  className="pl-0 sm:pl-12 md:pl-16  mt-2"
                  >
                  <GatsbyImage
                    image={getImage(data.stickyQuotemedia.file)}
                    alt={data.stickyQuotemedia.alternativeText || "Alternative Text missing"}
                  />
                  {data.stickyQuotemedia.caption && <p className="inline-flex pl-4 pr-16 sm:pl-0 sm:pr-0 mt-2 mb-0 text-text-sm tracking-text-sm leading-text-sm text-black/50 max-w-xl">{data.stickyQuotemedia.caption}</p>}
                </motion.div>
                }
              </div>
            </div>
          </div>
        </article>
      )}
    </>
  )
}

export default StickyQuote
